import {
  FAQS,
  AnalyticsHeader,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/Albuquerque-isotopes-primary.png";
const OrderSummaryBackgroundImage =
  "https://ss-leagues.s3.amazonaws.com/Minor%20League%20Baseball/DBH%20Pass%20Assets/Albq%20Isotopes/Attend_IsotopesLawnPass_BackgroundImage_1920x450.png";

export const albuquerqueisotopes_pass: TTeamConfig = {
  TEAM_SCHEMA: "albuquerqueisotopes_pass",
  TEAM_FULL_NAME: "Albuquerque Isotopes",
  BROWSER_TITLE: "Isotopes Pass",
  CLIENT_ID: "07ddf826a301.seasonshare.isotopes-isotopes.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#231f20",
    COLORS_SECONDARY: "#d31145",
    ANALYTICS_HEADER: AnalyticsHeader,
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },
    PASS_PRICE_OVERRIDES: [
      {
        PASS_ID: 3,
        PRICE: 199,
      },
    ],
    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_COLOR: "#d31145",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: LogoImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBackgroundImage,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
